import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, KeyRound, Globe, Key, ChevronRight } from 'lucide-react';
import { useTranslation } from '../context/LanguageContext';

const UserProfile = () => {
  const { t, lang, changeLanguage } = useTranslation();
  const navigate = useNavigate();

  const menuItems = [
    {
      icon: <User size={22} />,
      title: t('profile.view_profile'),
      path: '/profile/view',
    },
    {
      icon: <KeyRound size={22} />,
      title: t('profile.change_password'),
      path: '/profile/change-password',
    },
  ];

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">{t('profile.title')}</h1>

      {/* Menu Cards */}
      <div className="grid grid-cols-1 gap-4">
        {menuItems.map((item, idx) => (
          <button
            key={idx}
            onClick={() => navigate(item.path)}
            className="w-full flex items-center justify-between p-5 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-sm hover:shadow-md hover:border-blue-200 dark:hover:border-blue-800 transition-all text-left"
          >
            <div className="flex items-center gap-4">
              <div className="p-2.5 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-xl">
                {item.icon}
              </div>
              <span className="text-base font-medium text-slate-800 dark:text-white">{item.title}</span>
            </div>
            <ChevronRight size={20} className="text-slate-300 dark:text-slate-600" />
          </button>
        ))}
      </div>

      {/* Language Preference - Inline */}
      <div className="flex items-center justify-between p-5 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-sm">
        <div className="flex items-center gap-4">
          <div className="p-2.5 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-xl">
            <Globe size={22} />
          </div>
          <div>
            <span className="text-base font-medium text-slate-800 dark:text-white">{t('profile.language_preference')}</span>
            <p className="text-xs text-slate-400 mt-0.5">{t('common.current_language_display')}</p>
          </div>
        </div>
        <select
          value={lang}
          onChange={(e) => changeLanguage(e.target.value)}
          className="px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 text-sm outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer"
        >
          <option value="zh">{t('profile.chinese')}</option>
          <option value="en">{t('profile.english')}</option>
        </select>
      </div>
    </div>
  );
};

export default UserProfile;
